import axios from "axios";

export const http = axios.create({
  baseURL: "http://72.61.135.109:3000",
 // baseURL: "http://pesquisa06.lages.ifsc.edu.br:3334",
  // baseURL: "http://127.0.0.1:3333",
  timeout: 100000,
  responseType: "json",
});

export const setToken = (token) => {
  http.defaults.headers.common["Authorization"] = `Bearer ${token.token}`;
};
